
import { defineComponent, PropType, ref } from 'vue';

import ClaimNoteItem from '@/components/ClaimNoteItem.vue';
import { IClaimNote, IClaimNoteOrReply, Nullable } from '@/types';

export default defineComponent({
  name: 'ClaimNote',
  components: {
    ClaimNoteItem,
  },
  props: {
    claimId: {
      type: Number,
      required: true,
    },
    note: {
      type: Object as PropType<Nullable<IClaimNote>>,
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: 'Notes',
    },
  },
  emits: ['save'],
  setup(props, { emit }) {
    const newNote = ref<Nullable<IClaimNote>>(null);

    const onAddNote = () => {
      if (!props.claimId || !!props.note) {
        return;
      }

      newNote.value = {
        noteType: 'note',
        type: 'PUBLIC',
        text: '',
        replies: [],
        // eslint-disable-next-line @typescript-eslint/camelcase
        claim_id: props.claimId,
      };
    };

    function onCancelNote(): void {
      newNote.value = null;
    }

    function onSaveNote(updatedNote: IClaimNoteOrReply): void {
      emit('save', updatedNote);
      newNote.value = null;
    }

    return {
      newNote,
      onAddNote,
      onSaveNote,
      onCancelNote,
    };
  },
});
